import React, { useEffect, useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { CiCircleRemove } from "react-icons/ci";
import { CgSearch } from "react-icons/cg";
import "./ShopPage2.css";
import { FaRegHeart } from "react-icons/fa";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import { IoStar } from "react-icons/io5";
import { FaHeart } from "react-icons/fa6";
import FilterSection from "../../components/ShopPageComponents/FilterSection.js";
import SortMenuComponent from "../../components/ShopPageComponents/SortMenuComponent";
import Header from "../../components/layout/header.js";
import Footer from "../../components/layout/footer.js";
import ProductsContainer from "../../components/ShopPageComponents/ProductsContainer";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../constant";
import FlashSale from "../Flash Sale/FlashSale.js";
const ShopPage2 = ({ navigatedCategory, setNavigatedCategory }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const [openingCategory, setOpeningCategory] = useState("");
  const [currentProducts, setCurrentProducts] = useState([]);
  const [values, setValues] = useState([0, 30000]);
  const [sortByAlphabatically, setSortByAlphabatically] = useState(false);
  const [currentSubcategory, setCurrentSubcategory] = useState(null);
  const [stockStatus, setStockStatus] = useState("");
  const [scheme, setScheme] = useState("");
  const [shape, setShape] = useState("");
  const [isFilterClicked, setIsFilterClicked] = useState(false);
  const location = useLocation();

  const [categories, setCategories] = useState([]);
  const [colors, setColors] = useState([]);
  const [brands, setBrands] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [maxPrice, setMaxPrice] = useState(0);
  const [minPrice, setMinPrice] = useState(0);
  const [tempValues, setTempValues] = useState([minPrice, maxPrice]);
  const [isFiltered, setIsFiltered] = useState(false);

  // Fetch categories from the API
  useEffect(() => {
    fetch(`${BASE_URL}/category/all-unhide`)
      .then((response) => response.json())
      .then((data) => {
        setCategories(data);
      })
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);

  useEffect(() => {
    fetch(`${BASE_URL}/api/customProducts/all-colors`)
      .then((response) => response.json())
      .then((data) => {
        setColors(data);
      })
      .catch((error) => console.error("Error fetching colors:", error));
  }, []);

  useEffect(() => {
    fetch(`${BASE_URL}/api/customProducts/all-brands`)
      .then((response) => response.json())
      .then((data) => {
        setBrands(data);
      })
      .catch((error) => console.error("Error fetching brands:", error));
  }, []);

  useEffect(() => {
    fetch(`${BASE_URL}/api/customProducts/all-sizes`)
      .then((response) => response.json())
      .then((data) => {
        setSizes(data);
      })
      .catch((error) => console.error("Error fetching sizes:", error));
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const search = queryParams.get("search") || "";
    const navigatedCategory = queryParams.get("category") || "";
    setSearchTerm(search);
    if (navigatedCategory) {
      showNavigatedCategoryProducts(navigatedCategory);
      setNavigatedCategory(navigatedCategory);
    }
  }, [location.search]);

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const fetchMaxPrice = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/customProducts/all`);
      const products = response.data;
      const maxPrice = Math.max(
        ...products.map((product) => product.productPrice)
      );
      setValues([0, maxPrice]); // Set the price range dynamically
    } catch (error) {
      console.error("Error fetching max price:", error);
    }
  };

  useEffect(() => {
    fetchMaxPrice();
  }, []);

  const showNavigatedCategoryProducts = async (navigatedCategory) => {
    if (navigatedCategory == "men") {
      setOpeningCategory(1);
      setCurrentSubcategory("");
    }
    if (navigatedCategory == "women") {
      setOpeningCategory(2);
      setCurrentSubcategory("");
    }
    if (navigatedCategory == "kids") {
      setOpeningCategory(3);
      setCurrentSubcategory("");
    }
    if (navigatedCategory == "corporategifts") {
      setOpeningCategory(4);
      setCurrentSubcategory("");
    }
    if (navigatedCategory == "shapewear") {
      setOpeningCategory(5);
      setCurrentSubcategory("");
    }
  };

  return (
    <div style={{ background: "#f8f8f8" }}>
      <Header setNavigatedCategory={setNavigatedCategory} />
      <div className="shop-container">
        <FilterSection
          setSelectedCategory={setSelectedCategory}
          openingCategory={openingCategory}
          setOpeningCategory={setOpeningCategory}
          setCurrentSubcategory={setCurrentSubcategory}
          setCurrentProducts={setCurrentProducts}
          scheme={scheme}
          setScheme={setScheme}
          shape={shape}
          setShape={setShape}
          setNavigatedCategory={setNavigatedCategory}
          categories={categories}
          colors={colors}
          sizes={sizes}
          brands={brands}
          isFilterClicked={isFilterClicked}
          setIsFilterClicked={setIsFilterClicked}
        />
        <div className="shop-products-container">
          <h1
            style={{
              fontWeight: "bold",
              fontSize: "25px",
              margin: "10px",
              textTransform: "capitalize",
            }}
          >
            {navigatedCategory ? navigatedCategory : "All Products"}
          </h1>
          <SortMenuComponent
            setSelectedCategory={setSelectedCategory}
            searchTerm={searchTerm}
            onSearch={handleSearch}
            setCurrentProducts={setCurrentProducts}
            values={values}
            setValues={setValues}
            sortByAlphabatically={sortByAlphabatically}
            setSortByAlphabatically={setSortByAlphabatically}
            stockStatus={stockStatus}
            setStockStatus={setStockStatus}
            openingCategory={openingCategory}
            setOpeningCategory={setOpeningCategory}
            currentSubcategory={currentSubcategory}
            setCurrentSubcategory={setCurrentSubcategory}
            scheme={scheme}
            setScheme={setScheme}
            shape={shape}
            setShape={setShape}
            setNavigatedCategory={setNavigatedCategory}
            categories={categories}
            colors={colors}
            sizes={sizes}
            brands={brands}
            minPrice={minPrice}
            maxPrice={maxPrice}
            setMaxPrice={setMaxPrice}
            tempValues={tempValues}
            setTempValues={setTempValues}
            isFiltered={isFiltered}
            setIsFiltered={setIsFiltered}
          />
          <ProductsContainer
            searchTerm={searchTerm}
            currentProducts={currentProducts}
            setCurrentProducts={setCurrentProducts}
            values={values}
            sortByAlphabatically={sortByAlphabatically}
            currentSubcategory={currentSubcategory}
            stockStatus={stockStatus}
            scheme={scheme}
            openingCategory={openingCategory}
            shape={shape}
            isFilterClicked={isFilterClicked}
            tempValues={tempValues}
            isFiltered={isFiltered}
            selectedCategory={selectedCategory}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ShopPage2;
